'use client';

import React, {ComponentProps} from 'react';
import {Link as IntlLink} from '@/i18n/navigation';

type IntlLinkProps = ComponentProps<typeof IntlLink>;

type LinkBehaviorProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: IntlLinkProps['href'];
};

export const MuiNextLink = React.forwardRef<HTMLAnchorElement, LinkBehaviorProps>(
  function LinkBehavior(props, ref) {
    const { href, ...other } = props;
    return <IntlLink ref={ref} href={href} {...other} />;
  },
);
